import React, { useState, useEffect } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import * as Yup from "yup";
import moment from "moment";
import { Else, If, Then } from "react-if";
import { DatePicker, Drawer, Divider } from "antd";
import { notify } from "react-notify-toast";
import { Form, Formik } from "formik";

import {
  searchPatients,
  searchMorePatients,
  chatpatient,
  AddPatient,
  emptyReducerAction,
  activePatientSagaAction,
  PatientCountAction,
} from "../../../../sagas/saga-actions";
import NoInternetAction from "../../../../actions/noInternetAction";
import CustomInput from "../../../../components/customInput";
import CustomLabel from "../../../../components/customLabel";
import CustomButton from "../../../../components/customButton";
import { formInitialValues } from "../../constants";
import LoadingSpinner from "../../../../components/loadingSpinner";
import CommonService from "../../../../service/CommonService";
import CustomNotification from "../../../../components/notification";

import "./styles.scss";
import { setPopup } from "../../../../actions/popupAction";
import {
  EHR_NAME,
  EPIC_EHR_WHITELABEL,
  NEXTGEN_EHR_WHITELABEL,
  TABLET_SMALL,
  VERADIGM_EHR_WHITELABEL,
} from "../../../../constants/constants";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import { crossIcon } from "../../../../assets/svg";
import MobileHeader from "../../../../components/header/mobileHeader";

const commonService = new CommonService();

const PatientLookup = (props) => {
  props && props.reset && props.reset();
  const [state, setState] = useState({
    visible: props?.visible,
    patientsData: {
      fetched: false,
    },
    loading: false,
    count: 0,
    pageSize: 10, // for drchrono api call
    initialValues: formInitialValues,
    notConfigured: true,
    errorMessage: null,
  });

  const { user } = props;

  const checkConfigurationData = async () => {
    try {
      const checkConfigurationExists = await commonService.fetchAppointmentData();

      if (!checkConfigurationExists) {
        setState((st) => ({
          ...st,
          notConfigured: false,
          errorMessage:
            "Please add configurations for your account to fetch data",
          clickedSearch: false,
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  /**** Close search patient model */
  const closeSearch = async (param) => {
    try {
      props.emptyReducerAction();

      const { user } = props;

      let patientData = {},
        ehrName = user?.practice?.ehrName
          ? user?.practice?.ehrName?.toLowerCase()
          : "";

      patientData["claimedUserId"] = user ? user.id : "";
      patientData["ehr"] = ehrName;
      patientData["ehrPatientId"] = param.ehrPatientId
        ? param.ehrPatientId
        : null;
      patientData["cellPhone"] = param?.cellPhone
        ? param?.cellPhone.toString()
        : null;
      patientData["active"] = true;
      patientData["practiceId"] = user?.practiceId ? user.practiceId : "";
      patientData["userName"] = user?.username ? user.username : "";
      patientData["medicalRecordNumber"] = param?.medicalRecordNumber
        ? param.medicalRecordNumber
        : undefined;
      patientData["firstName"] = param?.firstName;
      patientData["lastName"] = param?.lastName;
      patientData["dateOfBirth"] = param?.dateOfBirth ? param?.dateOfBirth : "";

      props.AddPatient(patientData, (data, response) => {
        const event = new CustomEvent("updateTab");
        window.dispatchEvent(event);
        const eventHeader = new CustomEvent("showChat");
        window.dispatchEvent(eventHeader);
        if (!data) {
          props.setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: response,
          });
        }
      });

      setState((st) => ({
        ...st,
        modal: !st.modal,
      }));

      setTimeout(() => {
        props.onClose();
      }, 300);

      if (user && user.id) {
        const obj = {
          userId: user.id,
          offset: 0,
        };

        props.activePatientSagaAction(obj);
      }

      if (param && param.cellPhone) {
        props.chatpatient(param);

        setState((st) => ({ ...st, modal: !st.modal }));

        setTimeout(() => {
          props.onClose();
          props.patientCount();
          props.history.push("/chat");
        }, 300);

        if (user && user.id) {
          const obj = {
            userId: user.id,
            offset: 0,
          };

          props.activePatientSagaAction(obj);
        }
      } else {
        let myColor = { background: "#44aade", text: "#FF0000" };
        notify.show(
          "No mobile number associated with this patient",
          "custom",
          20000,
          myColor
        );
      }
    } catch (err) {}
  };

  /***** Search patient data */
  const submitpatientsearch = async (formProps) => {
    const { user } = props;
    props.noInternetAction();
    let ehrName = user?.practice?.ehrName;
    let obj = {
      fname: formProps?.fname?.trim() || undefined,
      lname: formProps?.lname?.trim() || undefined,
      mrn: formProps?.mrn?.trim() || undefined,
      isConfigured: state.notConfigured ? true : false,
    };
    if (formProps.dob) {
      if (ehrName === "Nextgen") {
        obj.dob = moment(formProps.dob, "YYYY/MM/DD").format("YYYY-MM-DD");
      } else if (ehrName === "Athena") {
        obj.dob = moment(formProps.dob, "YYYY/MM/DD").format("MM/DD/YYYY");
      } else if (ehrName === "Epic") {
        obj.dob = moment(formProps.dob, "YYYY/MM/DD").format("YYYY-MM-DD");
      }
    }
    if (ehrName === "DrChrono") {
      obj.pageSize = state.pageSize;
    }

    setState((st) => ({
      ...st,
      search: true,
      loading: true,
      errorMessage: null,
    }));

    try {
      !props.noInternet.noInternetMessage &&
        props.searchPatients(obj, (status, data) => {
          const result = data?.data?.data ? data.data.data : null;

          if (status && result) {
            setState((st) => ({
              ...st,
              patientsData: { fetched: true, ...result },
              loading: false,
              count: result.count,
            }));
          } else {
            setState((st) => ({
              ...st,
              patientsData: { fetched: false },
              loading: false,
            }));
            props.setPopup({
              customPopupMessage: true,
              message: "Failed to fetch records",
              messageType: "error",
            });
          }
        });
    } catch (err) {
      setState((st) => ({
        ...st,
        patientsData: { fetched: false },
        loading: false,
      }));

      props.setPopup({
        customPopupMessage: true,
        message: "Something went wrong!",
        messageType: "error",
      });
    }
  };

  const fetchMorePatients = (url) => {
    props.searchMorePatients({ url }, (status, data) => {
      if (status) {
        setState((st) => ({
          ...st,
          patientsData: { fetched: true, ...data.data.data },
          loading: false,
        }));
      } else {
        setState((st) => ({
          ...st,
          patientsData: { fetched: false },
          loading: false,
        }));
      }
    });
  };

  useEffect(() => {
    checkConfigurationData();
    props.noInternetAction();
  }, []);

  const { patientsData, loading, count } = state;
  let patient_data, objPatient;
  if (props.patients) {
    patient_data = props.patients;
    if (patient_data?.patient?.data?.data) {
      objPatient = patient_data?.patient?.data?.data[0];
    }
  }
  let ehrName = EPIC_EHR_WHITELABEL ? props?.user?.practice?.ehrName : EHR_NAME;

  const patientLookupSchema = Yup.object().shape({
    fname: Yup.string()
      .when("mrn", {
        is: (value) => !value,
        then: Yup.string().required("First name is required"),
      })
      .max(255, "First name cannot be greater than 255 characters"),
    lname: Yup.string()
      .when("mrn", {
        is: (value) => !value,
        then: Yup.string().required("Last name is required"),
      })
      .max(255, "Last name cannot be greater than 255 characters"),
    dob:
      ehrName === "Epic" &&
      Yup.string().when("mrn", {
        is: (value) => !value,
        then: Yup.string().nullable(),
      }),
    mrn: Yup.string()
      .max(30, " MRN number must be not more than 30 characters")
      .matches(/\S/, "Please enter vaild characters"),
  });

  const { customPopupMessage, messageType, message } = props.popupReducer;
  const { width } = useWindowDimensions();

  return (
    <>
      {customPopupMessage && (
        <CustomNotification messageType={messageType} message={message} />
      )}
      {/* Header */}
      <div className="header-bar-mob">
        <MobileHeader
          showLogo={false}
          showNotifications={false}
          showHelp={false}
          showAccountDetails={false}
          showBackButton={true}
          showPageTitle={true}
          pageTitle="Patient Lookup"
          handleBackButton={props.onClose}
          backgroundColor={NEXTGEN_EHR_WHITELABEL ? "black-bg" : ""}
        />
      </div>
      <Drawer
        title="Patient Lookup"
        placement="right"
        className="patient-drawer"
        onClose={props.onClose}
        visible={state.visible}
      >
        <Formik
          enableReinitialize
          initialValues={state.initialValues}
          validationSchema={patientLookupSchema}
          onSubmit={(values) => {
            submitpatientsearch(values);
          }}
        >
          {({
            touched,
            dirty,
            errors,
            isValid,
            values,
            setFieldValue,
            setFieldTouched,
            handleReset,
            handleChange,
          }) => {
            const disableFutureDt = (current) => {
              return current && current > moment().add(0, "day");
            };

            return (
              <Form className="fields-wrapper">
                {width < TABLET_SMALL && (
                  <span className="close-icon" onClick={props.onClose}>
                    {crossIcon}
                  </span>
                )}
                <section className="form-row">
                  <CustomInput
                    required={!values.mrn}
                    disabled={values.mrn}
                    title="First Name"
                    className={"custom-form-input"}
                    placeholder="John"
                    name="fname"
                  />
                </section>

                <section className="form-row">
                  <CustomInput
                    required={!values.mrn}
                    disabled={values.mrn}
                    title="Last Name"
                    className={"custom-form-input"}
                    placeholder="Chem"
                    name="lname"
                  />
                </section>

                {ehrName !== "Cerner" && (
                  <section className="form-row">
                    <CustomLabel title="Date of Birth" />
                    <DatePicker
                      disabled={values.mrn}
                      className={`common-date-time ${
                        touched.dob && errors.dob ? "error-box" : ""
                      }`}
                      onChange={(value) => setFieldValue("dob", value)}
                      onBlur={() => setFieldTouched("dob", true)}
                      value={values.dob}
                      format={["MM-DD-YYYY", "MM/DD/YYYY"]}
                      placeholder="MM-DD-YYYY or MM/DD/YYYY"
                      name="dob"
                      style={{ width: 240 }}
                      disabledDate={disableFutureDt}
                    />
                    {touched.dob && errors.dob ? (
                      <div className="error-label">{errors.dob}</div>
                    ) : null}
                  </section>
                )}
                {(ehrName === "Epic" || VERADIGM_EHR_WHITELABEL) && (
                  <>
                    <Divider>
                      <span className="divider">OR</span>
                    </Divider>
                    <section className="form-row">
                      <CustomInput
                        disabled={values.fname || values.lname || values.dob}
                        title="MR Number"
                        className={"custom-form-input"}
                        placeholder="MR number"
                        name="mrn"
                      />
                    </section>
                  </>
                )}
                {/* {ehrName === 'Epic' &&
                  // !values.isEhr && (
                  !values.isEhr && (
                    <section className="form-row">
                      <CustomLabel title="Gender" />
                      <FormikSelect
                        name="gender"
                        // showSearch
                        className={`common-select-field ${
                          touched.gender && errors.gender ? 'error-box' : ''
                        }`}
                        placeholder="Select Gender"
                        //   disabled={state.edit && true}
                        getPopupContainer={(trigger) => trigger.parentNode}
                        style={{ width: 174 }}
                      >
                        {gender.map((item) => {
                          return (
                            <Option key={item.value} value={item.value}>
                              {item.label}
                            </Option>
                          );
                        })}
                      </FormikSelect>

                      {touched.gender && errors.gender ? (
                        <div className="error-label">{errors.gender}</div>
                      ) : null}
                    </section>
                  )} */}

                <section className="form-actions">
                  <section className="form-buttons">
                    <CustomButton
                      htmlType="submit"
                      type="primary"
                      className={
                        !(isValid && dirty) || state.loading
                          ? "disable-button"
                          : ""
                      }
                      disabled={!(isValid && dirty) || state.loading}
                      title="Search"
                    />

                    <CustomButton
                      className="ml-8"
                      onClick={() => {
                        handleReset();
                        setState((st) => ({
                          ...st,
                          patientsData: {
                            fetched: false,
                          },
                          count: 0,
                          loading: false,
                        }));
                      }}
                      btntype="clear"
                      title="Reset"
                    />
                  </section>
                </section>
              </Form>
            );
          }}
        </Formik>

        <If condition={props.noInternet.noInternetMessage}>
          <Then>
            <article className="search-result-section-container">
              <section
                className={`search-result-section ${props.noInternet
                  .noInternetMessage && "error-message"}`}
              >
                <span className="default-content">
                  {props.noInternet.noInternetMessage}
                </span>
              </section>
            </article>
          </Then>
          <Else>
            <article className="search-result-section-container">
              <section className="search-result-section">
                {!patientsData?.fetched &&
                  !loading && (
                    <p className="default-content">
                      Please use the filters above to narrow your search result.
                    </p>
                  )}
                {loading && <LoadingSpinner type="small" />}

                {!loading &&
                  patientsData?.fetched &&
                  (patientsData?.PatientResponseresults?.length > 0 ? (
                    <div className="search-content">
                      <h1 className="result-count">
                        Showing Results: <strong>{count}</strong>
                      </h1>

                      <div className="list-wrapper">
                        {Array.isArray(patientsData?.PatientResponseresults) &&
                          patientsData?.PatientResponseresults?.map(
                            (obj, index) => {
                              const isStartChatDisabled =
                                user.department !== obj.departmentId &&
                                obj.departmentId !== null;
                              return (
                                <div
                                  className="list"
                                  key={
                                    obj.cellPhone
                                      ? obj.cellPhone
                                      : obj.firstName
                                  }
                                >
                                  <p className="name">
                                    {obj.firstName} {obj.lastName}
                                  </p>
                                  {obj.cellPhone ? (
                                    <p className="cellphone">{obj.cellPhone}</p>
                                  ) : (
                                    <p className="no-number-available">
                                      No number available
                                    </p>
                                  )}

                                  {obj.cellPhone ? (
                                    <CustomButton
                                      title="Start Chat"
                                      btntype="clear"
                                      className={
                                        isStartChatDisabled
                                          ? "disable-button"
                                          : ""
                                      }
                                      onClick={() => {
                                        closeSearch(obj);
                                      }}
                                      disabled={isStartChatDisabled}
                                    />
                                  ) : (
                                    <p className="disable-start-chat-button">
                                      Start Chat
                                    </p>
                                  )}
                                </div>
                              );
                            }
                          )}
                      </div>

                      {(patientsData?.previous || patientsData?.next) && (
                        <div className="text-center">
                          <button
                            className="btn p-0 box-shadow-none"
                            disabled={patientsData.previous === null}
                            onClick={() =>
                              fetchMorePatients(patientsData.previous)
                            }
                          >
                            Prev
                          </button>

                          <button
                            className="btn p-0 box-shadow-none"
                            disabled={patientsData.next === null}
                            onClick={() => fetchMorePatients(patientsData.next)}
                          >
                            Next
                          </button>
                        </div>
                      )}
                    </div>
                  ) : (
                    <p className="default-content">No result found.</p>
                  ))}
              </section>
            </article>
          </Else>
        </If>
      </Drawer>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    patients: state.patients,
    user: state.login.user,
    noInternet: state.noInternet,
    popupReducer: state.popupReducer,
  };
};

const mapDispatchToProps = (dispatch) => ({
  searchPatients: bindActionCreators(searchPatients, dispatch),
  searchMorePatients: bindActionCreators(searchMorePatients, dispatch),
  chatpatient: bindActionCreators(chatpatient, dispatch),
  AddPatient: bindActionCreators(AddPatient, dispatch),
  emptyReducerAction: bindActionCreators(emptyReducerAction, dispatch),
  activePatientSagaAction: bindActionCreators(
    activePatientSagaAction,
    dispatch
  ),
  patientCount: bindActionCreators(PatientCountAction, dispatch),
  noInternetAction: () => dispatch(NoInternetAction()),
  setPopup: (data) => dispatch(setPopup(data)),
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(PatientLookup)
);
